module.exports = __webpack_public_path__ + "static/img/is4.b7c219e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/institute/pic/is4.jpg
// module id = ympj
// module chunks = 11